import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideMenu from "../components/sideMenu";

const MainLayout = () => {
    const { pathname } = useLocation();
    const [collapse, setCollapseState] = useState(() => {
        return localStorage.getItem("sidebarCollapsed") === "true";
    });
    const [mobileOpen, setMobileOpen] = useState(false);

    const setCollapse = (val) => {
        setCollapseState((prev) => {
            const nextVal = typeof val === "function" ? val(prev) : val;
            localStorage.setItem("sidebarCollapsed", String(nextVal));
            return nextVal;
        });
    };

    const toggleMobileSidebar = () => {
        setMobileOpen(prev => !prev);
    };

    useEffect(() => {
        setMobileOpen(false);
    }, [pathname]);

    return (
        <div className="main_layout">
            {mobileOpen && (
                <div
                    className="mobile_sidebar_overlay"
                    onClick={() => setMobileOpen(false)}
                />
            )}
            <div className={`side_drawer ${collapse ? "collapsed" : ""} ${mobileOpen ? "mobile_open" : ""}`}>
                <SideMenu collapse={collapse} setCollapse={setCollapse} onNavigateMobile={() => setMobileOpen(false)} />
            </div>
            <div className={`right_dashboard ${collapse ? "collapsed" : ""}`}>
                <Outlet context={{ toggleMobileSidebar, mobileOpen, setMobileOpen }} />
            </div>
        </div>
    );
};

export default MainLayout;
